

import { Longread, Nullable, Profile, Team, TFile } from '@brg/api';
import { ORGANIZATION_LIST } from 'shared/hooks/useGetCurrentTeam';
import {ModuleFormat} from "../../../constants/ModuleFormat";
import {executeTypograf} from "../../../utils/executeTypograf";
import { PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTeam {
    name: string;
    teamId: string;
    has: boolean;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    cardId?: string;
    contexts: string[];
    ownersIDs?: string[];
    owners: Profile[];
    tabName?: any[];
    coverTitle: any;
    status: number;
    longread?: Longread;
    longreadId?: string;
    longreadId_en?: string;
    contextName?: string;
    isBilingual?: boolean;
    route?: string;
    formIds?: string[];
    tabs: any[];
    mainFilter?: any;
    anchorLinksLimit?: number;
    isSwitchButtonVisible?: boolean;
    isShowTeamLandingWithProjects?: boolean;
    longreadEntityLink: string;
    replaceLongreadId: string;
    longreadType?: number;
    additionalInfo: any;
    lmsCover?: number;
    lmsModuleFormat: ModuleFormat;
    moderationType?: number;
    subscribersCount?: number;
    lmsModuleStartDate: any;
    lmsModulePrice: any,
    lmsCourseTerm: any;
    mainEntityType?: string;
    isLinksInsteadTitle?: boolean;
    showQu?: boolean;
    topLinks: any[];
    quCount?: number;
    isQu?: boolean;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeTeam(team: Nullable<Partial<Team>>): ComputedTeam {

    const routeName = Object.entries(ORGANIZATION_LIST)?.filter(([current, val]) => (val.id === team?.teamId))[0];

    return {
        name: executeTypograf(team?.name ?? 'unnamed'),
        teamId: team?.teamId ?? '',
        additionalInfo: team?.additionalInfo || {},
        contextName: team?.contextName || '',
        contexts: team?.contexts || [],
        coverTitle: team?.coverTitle || [],
        has: !!team,
        titleImages: team?.titleImages ?? [],
        titleImages_en: team?.titleImages_en ?? [],
        longreadId: team?.longreadId ?? '',
        longreadId_en: team?.longreadId_en ?? '',
        longread: team?.longread ?? [],
        ownersIDs: team?.ownersIDs ?? [],
        owners: team?.owners ?? [],
        status: team?.status ?? PUBLISHED_TEAM_STATUS,
        lmsModuleStartDate: team?.lmsModuleStartDate ?? null,
        lmsModulePrice: team?.lmsModulePrice ?? 0,
        lmsModuleFormat: team?.lmsModuleFormat ?? ModuleFormat.PreRecorded,
        lmsCourseTerm: team?.lmsCourseTerm ?? null,
        tabName: routeName,
        tabs: team?.tabs || [],
        isBilingual: team?.isBilingual ?? false,
        moderationType: team?.moderationType ?? 0,
        mainEntityType: team?.mainEntityType,
        route: team?.route || (team?.contextName && `${team?.moderationType === 3 ? process.env.REACT_APP_URL_HSEDESIGN_LMS : process.env.REACT_APP_URL_HSEDESIGN_RU}/teams/${team?.contextName || ''}`),
        mainFilter: team?.mainFilter,
        formIds: team?.formIds || [],
        isSwitchButtonVisible: team?.isSwitchButtonVisible || false,
        isLinksInsteadTitle: team?.isLinksInsteadTitle || false,
        topLinks: team?.topLinks || [],
        isShowTeamLandingWithProjects: team?.isShowTeamLandingWithProjects || false,
        showQu: (team as any)?.showQu || false,
        quCount: (team as any)?.quCount || 0,
        isQu: (team as any)?.isQu || false,
        longreadEntityLink: team?.longreadEntityLink || '',
        replaceLongreadId: team?.replaceLongreadId || '',
        longreadType: team?.longreadType || 0,
        lmsCover: team?.lmsCover,
        subscribersCount: team?.subscribersCount || 0
    };
}

export const computeDataWithLang = (data: any) => {
    return {
        ...data,
        currentLang: 'ru'
    }
}


import { Longread, Nullable, Profile, Team, TFile } from '@brg/api';
import { ORGANIZATION_LIST } from 'shared/hooks/useGetCurrentTeam';
import {ModuleFormat} from "../../../constants/ModuleFormat";
import {executeTypograf} from "../../../utils/executeTypograf";
import { PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTeam {
    name: string;
    teamId: string;
    has: boolean;
    titleImages?: TFile[];
    titleImages_en?: TFile[];
    cardId?: string;
    contexts: string[];
    ownersIDs?: string[];
    owners: Profile[];
    tabName?: any[];
    coverTitle: any;
    status: number;
    longread?: Longread;
    longreadId?: string;
    longreadId_en?: string;
    contextName?: string;
    isBilingual?: boolean;
    route?: string;
    formIds?: string[];
    tabs: any[];
    mainFilter?: any;
    anchorLinksLimit?: number;
    isSwitchButtonVisible?: boolean;
    isShowTeamLandingWithProjects?: boolean;
    longreadEntityLink: string;
    replaceLongreadId: string;
    longreadType?: number;
    additionalInfo: any;
    lmsCover?: number;
    lmsModuleFormat: ModuleFormat;
    moderationType?: number;
    subscribersCount?: number;
    lmsModuleStartDate: any;
    lmsModulePrice: any,
    lmsCourseTerm: any;
    mainEntityType?: string;
    isLinksInsteadTitle?: boolean;
    showQu?: boolean;
    topLinks: any[];
    quCount?: number;
    isQu?: boolean;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeTeam(team: Nullable<Partial<Team>>): ComputedTeam {

    const routeName = Object.entries(ORGANIZATION_LIST)?.filter(([current, val]) => (val.id === team?.teamId))[0];

    return {
        name: executeTypograf(team?.name ?? 'unnamed'),
        teamId: team?.teamId ?? '',
        additionalInfo: team?.additionalInfo || {},
        contextName: team?.contextName || '',
        contexts: team?.contexts || [],
        coverTitle: team?.coverTitle || [],
        has: !!team,
        titleImages: team?.titleImages ?? [],
        titleImages_en: team?.titleImages_en ?? [],
        longreadId: team?.longreadId ?? '',
        longreadId_en: team?.longreadId_en ?? '',
        longread: team?.longread ?? [],
        ownersIDs: team?.ownersIDs ?? [],
        owners: team?.owners ?? [],
        status: team?.status ?? PUBLISHED_TEAM_STATUS,
        lmsModuleStartDate: team?.lmsModuleStartDate ?? null,
        lmsModulePrice: team?.lmsModulePrice ?? 0,
        lmsModuleFormat: team?.lmsModuleFormat ?? ModuleFormat.PreRecorded,
        lmsCourseTerm: team?.lmsCourseTerm ?? null,
        tabName: routeName,
        tabs: team?.tabs || [],
        isBilingual: team?.isBilingual ?? false,
        moderationType: team?.moderationType ?? 0,
        mainEntityType: team?.mainEntityType,
        route: team?.route || (team?.contextName && `${team?.moderationType === 3 ? process.env.REACT_APP_URL_HSEDESIGN_LMS : process.env.REACT_APP_URL_HSEDESIGN_RU}/teams/${team?.contextName || ''}`),
        mainFilter: team?.mainFilter,
        formIds: team?.formIds || [],
        isSwitchButtonVisible: team?.isSwitchButtonVisible || false,
        isLinksInsteadTitle: team?.isLinksInsteadTitle || false,
        topLinks: team?.topLinks || [],
        isShowTeamLandingWithProjects: team?.isShowTeamLandingWithProjects || false,
        showQu: (team as any)?.showQu || false,
        quCount: (team as any)?.quCount || 0,
        isQu: (team as any)?.isQu || false,
        longreadEntityLink: team?.longreadEntityLink || '',
        replaceLongreadId: team?.replaceLongreadId || '',
        longreadType: team?.longreadType || 0,
        lmsCover: team?.lmsCover,
        subscribersCount: team?.subscribersCount || 0
    };
}

export const computeDataWithLang = (data: any) => {
    return {
        ...data,
        currentLang: 'ru'
    }
}
